<div class="p-input-block02__item-title p-input-block02__item-title--m">
  <div class="p-input-block02__item-title-label p-input-block02__item-title-label--em">
    <div class="p-form-layout04__item-airport">
      <span class="p-form-layout04__item-airport-departure"
        >{{ departureAirport
        }}<span class="p-form-layout04__item-airport-to"
          ><span class="u-visually-hidden">to</span
          ><span aria-hidden="true" [innerHTML]="'label.hyphen' | staticMsg"></span></span></span
      ><span class="p-form-layout04__item-airport-arrival">{{ arrivalAirport }}</span>
    </div>
  </div>
</div>
<div class="p-input-block02__row">
  <div class="p-input-block02__row-body" *ngIf="appliedMealList.length">
    <ng-container *ngFor="let appliedMeal of appliedMealList">
      <div class="p-input-block02__row-body-item">
        <asw-flight-meal-detail
          [appliedMeal]="appliedMeal"
          [flight]="flight"
          [traveler]="traveler"
        ></asw-flight-meal-detail>
      </div>
    </ng-container>
  </div>
  <div class="p-input-block02__row-body" *ngIf="hasAppliedMeal !== true">
    <div class="p-input-block02__row-body-item">
      <asw-flight-meal-detail
        [isNotAppliedMeal]="!hasAppliedMeal"
        [flight]="flight"
        [traveler]="traveler"
      ></asw-flight-meal-detail>
    </div>
  </div>
  <div class="p-input-block02__row-body" *ngIf="isBabyMeal">
    <div class="p-input-block02__row-body-item">
      <asw-flight-meal-detail
        [isBabyMeal]="isBabyMeal"
        [flight]="flight"
        [traveler]="traveler"
      ></asw-flight-meal-detail>
    </div>
  </div>
</div>
